<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div class="giga-fields">
    <div
      :class="[
        addressValidator.workAddress.$anyDirty &&
        addressValidator.workAddress.$invalid
          ? 'field-hasError'
          : '',
        !addressValidator.workAddress.required ? 'field-isRequired' : ''
      ]"
      class="giga-input_field col-lg-4"
    >
      <label class="input-field_label">{{ $t("address_work") }}
        <span class="text-danger">*</span>
      </label>
      <div class="input-field_area">
        <input
          type="text"
          id="address_work"
          v-model="addressValidator.workAddress.$model"
          class="small-input"
          :disabled="isVIEWER"
        />
        <div
          class="validation-field-holder"
          v-if="
            addressValidator.workAddress.$anyDirty &&
              addressValidator.workAddress.$invalid
          "
        >
          <small v-if="!addressValidator.workAddress.required">
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
    </div>

    <div
      :class="[
        addressValidator.way.$anyDirty && addressValidator.way.$invalid
          ? 'field-hasError'
          : '',
        !addressValidator.way.required ? 'field-isRequired' : ''
      ]"
      class="giga-input_field col-lg-4"
    >
      <label class="input-field_label">{{ $t("way") }}
        <span class="text-danger">*</span>
      </label>
      <div class="input-field_area">
        <input
          type="text"
          id="way"
          v-model="addressValidator.way.$model"
          class="small-input"
          :disabled="isVIEWER"
        />
        <div
          class="validation-field-holder"
          v-if="addressValidator.way.$anyDirty && addressValidator.way.$invalid"
        >
          <small v-if="!addressValidator.way.required">
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
    </div>

    <div
        :class="[
        addressValidator.zipCode.$anyDirty && addressValidator.zipCode.$invalid
          ? 'field-hasError'
          : '',
        !addressValidator.zipCode.required ? 'field-isRequired' : ''
      ]"
        class="giga-input_field col-lg-4"
    >
      <label class="input-field_label">{{ $t("postal_code") }}
        <span class="text-danger">*</span>
      </label>
      <div class="input-field_area">
        <input
            type="text"
            id="postal_code"
            v-model="addressValidator.zipCode.$model"
            class="small-input"
            @keyup="emitZipCode"
            :disabled="isVIEWER"
        />
        <div
            class="validation-field-holder"
            v-if="
            addressValidator.zipCode.$anyDirty &&
              addressValidator.zipCode.$invalid
          "
        >
          <small v-if="!addressValidator.zipCode.required">
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
    </div>

    <div
      :class="[
        addressValidator.additionalInfo.$anyDirty &&
        addressValidator.additionalInfo.$invalid
          ? 'field-hasError'
          : '',
        !addressValidator.additionalInfo.required ? 'field-isRequired' : ''
      ]"
      class="giga-input_field col-lg-8"
    >
      <label class="input-field_label">{{ $t("additional_address") }}</label>
      <div class="input-field_area">
        <input
          type="text"
          id="additional_address"
          v-model="addressValidator.additionalInfo.$model"
          class="small-input"
          :disabled="isVIEWER"
        />
        <div
          class="validation-field-holder"
          v-if="
            addressValidator.additionalInfo.$anyDirty &&
              addressValidator.additionalInfo.$invalid
          "
        >
          <small v-if="!addressValidator.additionalInfo.required">
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
    </div>

    <div
      :class="[
        addressValidator.city.$anyDirty && addressValidator.city.$invalid
          ? 'field-hasError'
          : '',
        !addressValidator.city.required ? 'field-isRequired' : ''
      ]"
      class="giga-input_field col-lg-4"
    >
      <label class="input-field_label">{{ $t("city") }}
        <span class="text-danger">*</span>
      </label>
      <div class="input-field_area">
        <select
          id="city"
          v-model="addressValidator.city.$model"
          class="small-input"
          @change="emitCity"
          :disabled="isVIEWER"
        >
          <option
            v-for="city of addressValidator.cities.$model"
            :key="city.id"
            :value="city.nomCommune"
            >{{ city.nomCommune }}</option
          >
        </select>
        <div
          class="validation-field-holder"
          v-if="
            addressValidator.city.$anyDirty && addressValidator.city.$invalid
          "
        >
          <small v-if="!addressValidator.city.required">
            {{ $t("required_field") }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Address",
  props: ["addressValidator", "isVIEWER"],
  methods: {
    emitZipCode() {
      const _zipCodeLength = 5;
      if (this.addressValidator.zipCode.$model.length !== _zipCodeLength) {
        return;
      }
      this.$emit("onZipCodeChange", this.addressValidator);
    },
    emitCity() {
      this.$emit("onCityChange", this.addressValidator);
    }
  }
};
</script>

<style scoped></style>
